(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4762],{

/***/ 94762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Subscription; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/modules/subscription/Subscription.module.scss
var Subscription_module = __webpack_require__(84725);
var Subscription_module_default = /*#__PURE__*/__webpack_require__.n(Subscription_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./styles/modules/subscription/Card.module.scss
var Card_module = __webpack_require__(60962);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
// EXTERNAL MODULE: ./styles/modules/CheckMarkList.module.scss
var CheckMarkList_module = __webpack_require__(1653);
var CheckMarkList_module_default = /*#__PURE__*/__webpack_require__.n(CheckMarkList_module);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
;// CONCATENATED MODULE: ./components/Svg/CheckMark.js

function CheckMark(props) {
    var _shadow;
    var shadow = (_shadow = props.shadow) !== null && _shadow !== void 0 ? _shadow : "#0aa06e";
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#32ba7c";
    var isLegend = props.isLegend;
    if (isLegend) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "8",
                    cy: "8",
                    r: "8",
                    fill: "var(--color-blue)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "m12.4 6.406-5.124 5.151a.784.784 0 0 1-1.115 0L3.6 8.982a.794.794 0 0 1 0-1.121.784.784 0 0 1 1.115 0L6.72 9.876l4.567-4.59a.784.784 0 0 1 1.114 0c.308.309.308.81 0 1.12Z"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 507.2 507.2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "253.6",
                cy: "253.6",
                r: "253.6",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M188.8 368l130.4 130.4c108-28.8 188-127.2 188-244.8v-7.2L404.8 152l-216 216z",
                fill: shadow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M260 310.4c11.2 11.2 11.2 30.4 0 41.6l-23.2 23.2c-11.2 11.2-30.4 11.2-41.6 0L93.6 272.8c-11.2-11.2-11.2-30.4 0-41.6l23.2-23.2c11.2-11.2 30.4-11.2 41.6 0L260 310.4z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M348.8 133.6c11.2-11.2 30.4-11.2 41.6 0l23.2 23.2c11.2 11.2 11.2 30.4 0 41.6l-176 175.2c-11.2 11.2-30.4 11.2-41.6 0l-23.2-23.2c-11.2-11.2-11.2-30.4 0-41.6l176-175.2z"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Button.js + 2 modules
var Button = __webpack_require__(44217);
// EXTERNAL MODULE: ./components/Svg/Star.js
var Star = __webpack_require__(76997);
// EXTERNAL MODULE: ./api/index.js + 49 modules
var api = __webpack_require__(46979);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
// EXTERNAL MODULE: ./components/Svg/diamond.js
var diamond = __webpack_require__(5019);
// EXTERNAL MODULE: ./store/auth.js
var auth = __webpack_require__(32505);
;// CONCATENATED MODULE: ./components/Subscription/Card.js
















var Card = function(param) {
    var _product = param.product, name = _product.name, marketing_features = _product.marketing_features, data = param.data, currentPlan = param.plan, buttons = param.buttons, discount = param.discount, monthly = param.monthly;
    var ref;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), upgrade = ref2[0], setUpgrade = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var tag = (data === null || data === void 0 ? void 0 : data.type) !== "legend" && currentPlan.type === data.type && !currentPlan.registration ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (Card_module_default()).tag,
            (Card_module_default())["".concat(currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.type, "Tag")]
        ].join(" "),
        children: [
            (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.type) === "platinum" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(diamond/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    (Card_module_default()).ribbon,
                    (Card_module_default())["".concat(currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.type, "Ribbon")], 
                ].join(" ")
            })
        ]
    }) : null;
    var tagLegend = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            (Card_module_default()).tag,
            (Card_module_default())["".concat(data === null || data === void 0 ? void 0 : data.type, "Tag")]
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "35",
            height: "45",
            viewBox: "0 0 35 45",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 29.6471V0H35V29.6471L17.2464 45L0 29.6471Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23.4621 20.9375L23.1735 22.1891C23.1145 22.4444 22.8872 22.625 22.6251 22.625H11.3751C11.113 22.625 10.8857 22.4444 10.8266 22.1891L10.5381 20.9375H23.4621Z",
                    fill: "var(--color-blue)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24.8612 14.8766L23.7222 19.8125H10.2784L9.13936 14.8766C9.08929 14.6589 9.17254 14.4317 9.35198 14.2983C9.53198 14.165 9.77329 14.151 9.96679 14.2618L13.4481 16.2513L16.5317 11.6259C16.6324 11.4752 16.7989 11.3818 16.9795 11.375C17.1617 11.3672 17.3333 11.4493 17.4441 11.5922L21.0604 16.2418L24.0006 14.282C24.1924 14.1549 24.4427 14.156 24.6323 14.2871C24.8224 14.4182 24.9124 14.6522 24.8612 14.8766V14.8766Z",
                    fill: "var(--color-blue)"
                })
            ]
        })
    });
    var nextBilling = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Card_module_default()).info,
        children: currentPlan.type === "free" && data.interval === "year" && data.type !== "free" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "Monthly price: \xa3",
                (data.amount / 12 / 100).toFixed(2)
            ]
        })
    });
    var handleManage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var redirectUrl, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            (0,api/* postReq */.qu)("/stripe/customer-portal/session")
                        ];
                    case 2:
                        redirectUrl = _state.sent().data;
                        return [
                            4,
                            router.push(redirectUrl)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        console.log(e);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleManage() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpgrade = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var redirectUrl, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            (0,api/* postReq */.qu)("/stripe/checkout/session/subscription/".concat(data.type, "?billing=").concat(monthly ? "monthly" : "annual"))
                        ];
                    case 2:
                        redirectUrl = _state.sent().data;
                        // If this is a Contributing Editor upgrade, update the status immediately
                        if (data.type === "contributing_editor") {
                            dispatch((0,auth/* updateContributingEditorStatus */.bE)({
                                company: currentPlan.company
                            }));
                        }
                        return [
                            4,
                            router.push(redirectUrl)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        console.log(e);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpgrade() {
            return _ref.apply(this, arguments);
        };
    }();
    var button = {
        contributing_editor: (0,_object_spread/* default */.Z)({
            theme: "primary",
            title: "Upgrade",
            loading: loading,
            registration: false,
            classes: [
                (Card_module_default())[data.type]
            ],
            onClick: function() {
                var ref;
                if (buttons === null || buttons === void 0 ? void 0 : (ref = buttons.contributing_editor) === null || ref === void 0 ? void 0 : ref.registration) {
                    // During registration, just call the registration handler
                    buttons.contributing_editor.onClick();
                } else {
                    // During normal upgrade, proceed with Stripe
                    handleUpgrade();
                }
            }
        }, buttons && buttons.contributing_editor),
        free: (0,_object_spread/* default */.Z)({
            theme: "secondary",
            title: "Manage my subscription",
            loading: loading,
            classes: [
                (Card_module_default())[data.type]
            ],
            onClick: function() {
                return handleManage();
            }
        }, buttons && buttons.free),
        legend: (0,_object_spread/* default */.Z)({
            theme: "secondary",
            title: "awarded on merit",
            loading: loading,
            onClick: function() {},
            classes: [
                (Card_module_default()).legendBtn
            ]
        }, buttons && buttons.legend),
        premium: (0,_object_spread/* default */.Z)({
            theme: "secondary",
            title: "Upgrade",
            loading: loading,
            registration: false,
            onClick: function() {
                return (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.type) === "premium" ? handleManage() : handleUpgrade();
            },
            classes: [
                (Card_module_default()).premium
            ]
        }, buttons && buttons.premium),
        platinum: (0,_object_spread/* default */.Z)({
            theme: "secondary",
            title: "Upgrade",
            loading: loading,
            registration: false,
            onClick: function() {
                return (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.type) === "premium" ? handleManage() : handleUpgrade();
            },
            classes: [
                (Card_module_default()).platinum
            ]
        }, buttons && buttons.platinum)
    };
    var color = data.type === "contributing_editor" ? "var(--color-mint-ink)" : data.type === "platinum" ? "var(--color-platinum)" : data.type === "premium" ? "var(--color-premium)" : "var(--color-blue)";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: [
                "border-gray",
                (Card_module_default()).card,
                currentPlan.type === data.type && (Card_module_default()).active,
                (Card_module_default())[data.type], 
            ].join(" "),
            children: [
                tag,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (data === null || data === void 0 ? void 0 : data.type) === "legend" ? (Card_module_default()).legendBackground : undefined,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                fontSize: 14
                            },
                            children: currentPlan.type === data.type ? "Your active plan" : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "\xa0"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Card_module_default()).cardHeader,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: name
                                }),
                                data.sale && currentPlan.type !== data.type && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: [
                                        (Card_module_default()).saleTag,
                                        (Card_module_default())["".concat(data === null || data === void 0 ? void 0 : data.type, "Tag")], 
                                    ].join(" "),
                                    children: data.sale.amount
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Card_module_default()).price,
                            children: function() {
                                switch(data.type){
                                    case "free":
                                        return "Free";
                                    case "legend":
                                        return "Earned";
                                    default:
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                data.amountFormatted,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "/",
                                                        data.interval
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (Card_module_default()).vat,
                                                    children: [
                                                        " ",
                                                        "+ VAT"
                                                    ]
                                                })
                                            ]
                                        });
                                }
                            }()
                        })
                    ]
                }),
                nextBilling,
                !upgrade && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    style: {
                        lineHeight: "145%"
                    },
                    children: (ref = en/* subscriptions */.Vt[data === null || data === void 0 ? void 0 : data.type]) === null || ref === void 0 ? void 0 : ref.text
                }),
                !upgrade && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: [
                        (CheckMarkList_module_default()).list,
                        (Card_module_default()).list
                    ].join(" "),
                    children: (data.type === "free" ? en/* subscriptions.free.list.map */.Vt.free.list.map(function(name) {
                        return {
                            name: name
                        };
                    }) : marketing_features).map(function(feature, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckMark, {
                                        isLegend: data.type === "legend",
                                        fill: color,
                                        shadow: color
                                    })
                                }),
                                feature.name
                            ]
                        }, "".concat(data === null || data === void 0 ? void 0 : data.type, "-list-").concat(index));
                    })
                }),
                (data.type === "legend" && currentPlan.type !== "legend" || data.type === "free" && button[data.type].registration) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Card_module_default()).payment,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, button[data.type]))
                }),
                data.type === "premium" && currentPlan.type === "free" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Card_module_default()).payment,
                    children: !upgrade && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, button["premium"]))
                }),
                data.type === "contributing_editor" && (currentPlan.type === "free" || currentPlan.type === "premium" || currentPlan.type === "platinum") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Card_module_default()).payment,
                    children: !upgrade && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, button["contributing_editor"]))
                }),
                data.type === "platinum" && (currentPlan.type === "free" || currentPlan.type === "premium") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Card_module_default()).payment,
                    children: !upgrade && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, button["platinum"]))
                }),
                data.type === "premium" && (currentPlan.type === "premium" || button[data.type].registration) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, button["free"])),
                data.type === "contributing_editor" && (currentPlan.type === "contributing_editor" || button[data.type].registration) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, button["free"])),
                data.type === "platinum" && (currentPlan.type === "platinum" || button[data.type].registration) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, button["free"]))
            ]
        })
    });
};
/* harmony default export */ var Subscription_Card = (Card);

;// CONCATENATED MODULE: ./components/Subscription/Product.js




var Product = function(_param) {
    var product = _param.product, index = _param.index, res = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "index"
    ]);
    return product.plans.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscription_Card, (0,_object_spread/* default */.Z)({
        product: product,
        data: product.plans[index],
        monthly: index === 0
    }, res), index) : null;
};
/* harmony default export */ var Subscription_Product = (Product);

;// CONCATENATED MODULE: ./components/Subscription/Toggle.js


var Toggle = function(param) {
    var index = param.index, setIndex = param.setIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Subscription_module_default()).toggleWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Subscription_module_default()).toggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            (Subscription_module_default()).toggleButton,
                            index === 0 ? (Subscription_module_default()).left : (Subscription_module_default()).right, 
                        ].join(" ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: [
                            index === 0 ? (Subscription_module_default()).active : ""
                        ].join(" "),
                        onClick: function() {
                            return setIndex(0);
                        },
                        children: "Monthly"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: [
                            index === 1 ? (Subscription_module_default()).active : ""
                        ].join(" "),
                        onClick: function() {
                            return setIndex(1);
                        },
                        children: "Annual"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Subscription_module_default()).tooltip,
                children: "Get 20% off!"
            })
        ]
    });
};
/* harmony default export */ var Subscription_Toggle = (Toggle);

;// CONCATENATED MODULE: ./components/Subscription/index.js





var Stripe = function(param) {
    var products = param.products, plan = param.plan, buttons = param.buttons, discount = param.discount;
    var ref = (0,react.useState)(0), index = ref[0], setIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (!(plan === null || plan === void 0 ? void 0 : plan.type) || plan.type === "free") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscription_Toggle, {
                index: index,
                setIndex: setIndex
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Subscription_module_default()).cardWrapper,
                children: products.map(function(product) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscription_Product, {
                        product: product,
                        buttons: buttons,
                        plan: plan,
                        index: index,
                        discount: discount
                    }, product.id);
                })
            })
        ]
    });
};
/* harmony default export */ var Subscription = (Stripe);


/***/ }),

/***/ 1653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"CheckMarkList_list__DVfMx"};

/***/ }),

/***/ 60962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__7JGaF","active":"Card_active__vDa7N","free":"Card_free__sDEM8","premium":"Card_premium__CYhaB","cardHeader":"Card_cardHeader__VgGjH","saleTag":"Card_saleTag__0doFa","price":"Card_price__mkg30","vat":"Card_vat__itqEo","info":"Card_info__di_0M","flex":"Card_flex__OQp6N","input":"Card_input___WiQN","payment":"Card_payment__wKgwz","contributing_editorInfo":"Card_contributing_editorInfo__WWy6X","enter":"Card_enter___qIkE","enterActive":"Card_enterActive__Wfr_p","exit":"Card_exit__t_spj","exitActive":"Card_exitActive__YAa3E","enterStatus":"Card_enterStatus__NTVIR","enterStatusActive":"Card_enterStatusActive__3ZKsg","exitStatus":"Card_exitStatus__RUfuI","exitStatusActive":"Card_exitStatusActive__3PmwZ","tag":"Card_tag__Tkd8v","legendTag":"Card_legendTag__m9IF0","ribbon":"Card_ribbon__Q2dJq","secondaryBtn":"Card_secondaryBtn__M7SKB","legendBtn":"Card_legendBtn__b_GDU","cancelButton":"Card_cancelButton__neKTs","confirmButton":"Card_confirmButton__v1MvW","contributing_editor":"Card_contributing_editor__gvyba","list":"Card_list__uPeUv","platinum":"Card_platinum__3kd_d","contributing_editorTag":"Card_contributing_editorTag__53RCD","premiumTag":"Card_premiumTag__cTbpc","platinumTag":"Card_platinumTag__PY0N0","legend":"Card_legend__QWYgk","legendBackground":"Card_legendBackground__Cz2fV","contributing_editorRibbon":"Card_contributing_editorRibbon__S8NC9","premiumRibbon":"Card_premiumRibbon__uHkcz","platinumRibbon":"Card_platinumRibbon__JRnic","legendRibbon":"Card_legendRibbon__LVcp2","statusWrapper":"Card_statusWrapper__rqk8O"};

/***/ }),

/***/ 84725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Subscription_cardWrapper__n9uPe","toggleWrapper":"Subscription_toggleWrapper__Dk5_b","toggle":"Subscription_toggle__p2set","active":"Subscription_active__ca209","right":"Subscription_right__Pd8q4","left":"Subscription_left__HUqtk","tooltip":"Subscription_tooltip__SCbwn","toggleButton":"Subscription_toggleButton__jgRq6","disabled":"Subscription_disabled__84rBt","contributing_editor":"Subscription_contributing_editor__9BRe5","contributing_editorBorder":"Subscription_contributing_editorBorder__EoS_T","contributing_editorArrow":"Subscription_contributing_editorArrow__L0j2Q"};

/***/ })

}]);